<template lang='pug'>
  v-card
    v-card-title.dialog-card-title
      p {{$t('clients.title')}}
      v-icon(color="white" aria-label="Close" @click="$emit('close')") mdi-close
    v-card-text.mt-2
      v-flex(xs12='', md12='')
        .pa-1.purchase-form
          v-snackbar(v-model='snackbar',  :color='color', center top  :timeout="6000")
            | {{ message }}
          v-layout.column
            v-form(ref="form" v-model="valid")
              v-row
                  v-col(cols="12" md="6")
                      v-text-field(v-model='model.name' type='text' label='Nombre' required='')
                  v-col(cols="12" md="6")
                      v-text-field(v-model='model.identification' type='number' label='Cédula' required='')
                  v-col(cols="12" md="6")
                      v-text-field(v-model='model.email' type='email' label='Correo' :rules="rules.emailRules" required='')
                  v-col(cols="12" md="6")
                      v-text-field(v-model='model.phone' type='number' label='Teléfono' required='')
                  v-col(cols="12" md="12")
                      v-textarea(v-model='model.direction' :counter='100', label='Dirección' required='')
          .text-center
            v-btn(@click='cancel') Cancelar
            v-btn(color='#008e95', @click='validate' :loading="isLoading" :disabled ="isLoading || !model.name || !model.identification || !model.email" )
              | GUARDAR
</template>
<script>
  export default {
    components: {},
    filters: {},
    props: {
      model: Object,
    },
    data () {
      return {
        valid: true,
        isLoading: false,
        message: '',
        snackbar: false,
        color: 'success',
        rows: 1,
        valueType: '',
        slider: 10,
        e1: 0,
        show: false,
        isMobile: false,
        imageLoading: false,
        audioLoading: false,
      }
    },
    computed: {
      clients () {
        return this.$store.getters['clients/getClients']
      },
      rules () {
        return {
          emailRules: [
            v => !!v || 'Correo es requerido',
            v => /.+@.+\..+/.test(v) || 'El correo debe ser valido',
          ],
        }
      },
    },
    mounted () {
      // console.log(this.model)
      this.onResize()
    },

    methods: {
      validate () {
        const vm = this
        if (vm.$refs.form.validate()) {
          vm.save()
        } else {
          vm.message = 'Verifica los datos del formulario'
          vm.snackbar = true
          vm.color = 'red'
        }
      },
      reset () {
        this.model = {
          name: '',
          identification: '',
          email: '',
          phone: '',
          direction: '',
        }
      },
      cancel () {
        this.reset()
        this.$emit('close')
      },
      save () {
        // console.log(this.$store.state.users)
        const vm = this
        vm.isLoading = true
        const data = {
          client: vm.model,
          userId: vm.$store.state.users.user.uid,
          context: 'admin',
        }
        vm.$store.dispatch('clients/addUpdateClient', data).then((res) => {
          if (res === 'actualizado') {
            // console.log('entre 2')
            vm.isLoading = false
            vm.reset()
            vm.message = 'cliente actualizado correctamente'
            vm.snackbar = true
            vm.color = 'green'
            vm.$emit('close')
          } else if (res === 'creado') {
            vm.isLoading = false
            vm.reset()
            vm.$swal({
              icon: 'success',
              title: 'Cliente agregado',
              text: '¿Desea agregar otro cliente?',
              showCancelButton: true,
              confirmButtonText: 'Si',
              cancelButtonText: 'No',
            }).then((result) => {
              if (result.value) {
              } else {
                vm.$emit('close')
              }
            })
          } else if (res === 'cliente_ya_existe') {
            vm.isLoading = false
            vm.message = 'El usuario ya se encuentra registrado'
            vm.snackbar = true
            vm.color = 'red'
          }
        })
        /* const update = vm.model.id
        let found = ''
        vm.isLoading = true
        if (update) {
          found = vm.clients.find(element => element.identification === vm.model.identification && element.id !== vm.model.id)
        } else {
          found = vm.clients.find(element => element.identification === vm.model.identification)
        }
        if (found) {
          vm.isLoading = false
          vm.message = 'El usuario ya se encuentra registrado'
          vm.snackbar = true
          vm.color = 'red'
        } else {
          if (update) {
            vm.$store.dispatch('clients/updateClient', vm.model).then(function () {
              vm.isLoading = false
              vm.reset()
              vm.message = 'cliente actualizado correctamente'
              vm.snackbar = true
              vm.color = 'green'
              vm.$emit('close')
            })
          } else {
            vm.model.sendBill = false
            vm.$store.dispatch('clients/createClient', vm.model).then(function () {
              vm.isLoading = false
              vm.reset()
              vm.$swal({
                icon: 'success',
                title: 'Cliente agregado',
                text: '¿Desea agregar otro cliente?',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No',
              }).then((result) => {
                if (result.value) {
                  // console.log(result.value)
                } else {
                  vm.$emit('close')
                }
              })
            })
          }
        } */
      },

      onResize () {
        this.isMobile = window.innerWidth < 1024
      },
    },

  }
</script>
<style scoped lang="scss">
  $break-large: 1200px;
  $primary-color: #c29f52;

  .purchase-form{
    &__input{
      flex-wrap: wrap;
      @media screen and (min-width: $break-large) {
        flex-wrap: nowrap;
      }
    }
  }

  .grid-picker{
    text-align: center;
    min-width: 100%;
    display: grid;
    position: relative;
    flex: 1;
    width: 100%;
    grid-template-areas:

      'picture picture '
      'title title '
      'button button';
    @media screen and (min-width: $break-large) {
      grid-template-areas:

        'title picture picture '
        'title picture picture '
        'button button button';
      .image-slot{
        min-width: 400px;
        height: 250px;
        overflow: hidden;
      }
    }

    grid-gap: 10px;

    padding: 10px;
    .picker-btn{

      grid-area: button;
      flex: 1;
      height: 50px;
    }
    .image-slot{
      margin-left: auto;
      margin-right: auto;
      width: 100%;
      display: flex;
      grid-area: picture;
      max-width: 350px;
      max-height: 250px;
      background: #9e9e9e;
      align-items:center;
      justify-content: center;

    }
  }

  .phone-screen{

    background: url("/img/phone.png");
    display:flex;
    flex-direction: column;
    border-radius: 50px;
    border: 1px solid black;

    min-width: 379px;
    min-height: 736px;
    background-size:  379px 736px;
    background-repeat: no-repeat;
    margin:auto;
    overflow: hidden;
    &__content{

      overflow-y: auto;
      max-width: 382px;
      max-height: 595px;
      margin: auto !important;
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
      padding: 0 15px;
    }
  }
  .main-carousel{
    position: relative;
    &__overlay{
      position: absolute;
      bottom:0;
      left:0;
      right:0;
      height: 45px;
      width: 100%;
      margin: auto !important;
      background:rgba(#000,0.5);
      color: #fff;
      text-align: center;

    }
  }
  .property-values{
    border: 1px solid #c29f52;
    border-radius: 30px;
    height: auto;
    padding: 0 10px;
    h3{
      color:#c29f52;
      font-weight: 900;

    }
    .price-tooltip{
      color:#c29f52;
      font-weight: bold;
      margin:auto;
      margin-top:-10px;
      max-width: 100px;
      border: 1px solid #c29f52;
      border-radius: 15px;
      border-top-right-radius: 0;
      border-top-left-radius: 0;
      border-top: none;
    }
  }
  .numPayments{
    background: white !important;
    border: 1px solid #777;
    border-radius: 25px;
    width:auto;
    max-width: fit-content;

    &__button{
      color:#000 !important;
      border-radius: 40px;
    }
  }
  .v-input--slider{
    margin-top:0;
  }
  .v-tabs__container{
    max-width: 100%;
    overflow-x: auto;

  }
  .property-sections{
    span,b{
      font-size: 15px !important;
    }

    .v-tab{
      color: black !important;
    }
  }
  .property-toolbar{

  }
</style>
